export const ERROR_CODES = {
  /* 複数画面共通　*/
  COMMON_PHOTO_LIMIT_EXCEEDED: 'A10101',
  COMMON_BUILDING_GET_FAILED: 'A10102',
  COMMON_DEVICE_GET_ARG_INVALID: 'A10103',
  COMMON_DEVICE_ACTIVATION_ARG_INVALID: 'A10104',
  COMMON_DEVICE_UPDATE_ARG_INVALID: 'A10105',
  COMMON_READ_FILE_FAILED: 'A10106',
  COMMON_LABEL_GET_FAILED: 'A10107',
  COMMON_MAP_NOT_FOUND: 'A10108',

  /* ログイン画面 */
  LOGIN_DEVICE_GET_FAILED: 'A11001',
  LOGIN_GOVERNMENT_SETTINGS_GET_FAILED: 'A11002',
  LOGIN_DISASTER_GET_FAILED: 'A11003',
  LOGIN_GOVERNMENT_SETTINGS_EMPTY: 'A11004',
  LOGIN_AUTH_GET_FAILED: 'A11005',
  LOGIN_AUTHZ_DENIED: 'A11006',

  /* デバイス登録画面 */
  DEVICE_REGISTER_DEVICE_ACTIVATION_FAILED: 'A11101',
  DEVICE_REGISTER_DEVICE_UPDATE_FAILED: 'A11102',
  // APIレスポンス
  DEVICE_REGISTER_EXPIRED: '807140',
  DEVICE_REGISTER_ALREADY_USED: '807141',

  /* ホーム画面 */
  HOME_INSPECTION_RESULT_GET_FAILED: 'A11201',
  HOME_ADMIN_DISTRICTS_GET_FAILED: 'A11202',
  HOME_DISASTER_GET_FAILED: 'A11203',
  HOME_DISASTER_ID_NOT_EXIST: 'A11204',
  HOME_GOV_CODE_NOT_EXIST: 'A11205',
  HOME_TARGET_INSPECTION_NOT_FOUND: 'A11206',

  /* 調査員登録画面 */
  // なし

  /* 建物概要画面 */
  BUILDING_OVERVIEW_NOT_SPECIFIED: 'A11401',
  BUILDING_OVERVIEW_ADMIN_DISTRICTS_GET_FAILED: 'A11402',
  BUILDING_OVERVIEW_NOT_APPLICABLE: 'A11403',
  BUILDING_OVERVIEW_TARGET_BUILDING_NOT_FOUND: 'A11404',

  /* step1画面 */
  // なし

  /* step2画面 */
  STEP2_ALL_UNSELECTED: 'A11601',
  STEP2_STRING_CONVERSION_FAILED: 'A11602',
  STEP2_CONSTRUCTION_TYPE_UNSELECTED: 'A11603',

  /* 判定結果画面 */
  RESULT_TEXT_LIMIT_OVER: 'A11701',
  RESULT_PHOTO_LIMIT_EXCEEDED: 'A11702',
  RESULT_SAVE_FAILED: 'A11703',
  RESULT_PROPERTY_INVALID: 'A11704',

  /* 地図ダウンロード画面 */
  MAP_DOWNLOAD_ADMIN_DISTRICTS_GET_FAILED: 'A11801',
  MAP_DOWNLOAD_BUILDING_GET_FAILED: 'A11802',

  /* zipダウンロード */
  ZIP_CREATE_ERROR: 'A11901',
  ZIP_DOWNLOAD_ERROR: 'A11902'
} as const
